var _defs, _ellipse, _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _rect2, _rect3, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfinityWatching(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 223.301,
    height: 399.795,
    viewBox: "0 0 223.301 399.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.08,
    y1: 0.493,
    x2: 1.006,
    y2: 0.513,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebdc2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.034,
    stopColor: "#bc8e0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#ebdc2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#e7d62b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dfc825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#d0b01a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc8e0c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.031,
    y1: 0.475,
    x2: 1.028,
    y2: 0.491,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#ebdc2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#e7d62b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#dfc825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#d0b01a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#bc8e0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc8e0c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2.008,
    y1: 2.09,
    x2: 1.254,
    y2: -0.34,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2581c4",
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12715",
    "data-name": "Group 12715",
    transform: "translate(-148.35 -51.409)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_214",
    "data-name": "Ellipse 214",
    cx: 82.667,
    cy: 8.304,
    rx: 82.667,
    ry: 8.304,
    transform: "translate(168.9 434.594)",
    fill: "#707070",
    opacity: 0.18
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12356",
    "data-name": "Group 12356",
    transform: "translate(148.35 51.409)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12974",
    "data-name": "Path 12974",
    d: "M357.078,426.477q-.639,2.973-1.452,5.891A100.316,100.316,0,0,1,351.4,444.4a103.694,103.694,0,0,1-9.239,17.093,107.479,107.479,0,0,1-10.19,13.012A109.705,109.705,0,0,1,288.3,503.747q-4.69,1.7-9.566,2.94a102.989,102.989,0,0,1-75.781-9.87c-.654-.368-1.306-.744-1.948-1.127q-3.289-1.933-6.384-4.1c-.645-.451-1.282-.9-1.906-1.363-.1-.072-.2-.153-.305-.225a108.227,108.227,0,0,1-34.134-42.543c-.233-.522-.466-1.044-.7-1.574a111.613,111.613,0,0,1-4.932-13.7c-.167-.559-.325-1.115-.474-1.678a109.928,109.928,0,0,1-3.061-15.743,103.389,103.389,0,0,1-.758-13.208,98.828,98.828,0,0,1,2.045-19.534,93.206,93.206,0,0,1,6.919-20.727c7.324-15.635,18.163-27.672,28.676-36.543v-.008A135.024,135.024,0,0,1,199.7,314.614a119.853,119.853,0,0,1,18.265-9.842l.1,0c.282-.024.566-.047.847-.062a233.258,233.258,0,0,1,87.912,10.834q2.731.878,5.289,1.778c.009,0,.014.011.022.013.612.208,1.224.424,1.819.636.093.037.179.064.273.1q2.134,1.648,4.178,3.376c.236.195.463.395.689.594a118.387,118.387,0,0,1,23.067,26.679v.008a113.856,113.856,0,0,1,5.808,10.334c.982,1.981,1.907,3.991,2.759,6.02q.867,2.021,1.636,4.069a106.6,106.6,0,0,1,5.9,23.156,98.7,98.7,0,0,1,.93,11.745,97.392,97.392,0,0,1-2.118,22.425Z",
    transform: "translate(-148.351 -119.118)",
    fill: "#e9f0fa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12975",
    "data-name": "Path 12975",
    d: "M330.16,323.415a2.5,2.5,0,0,1-.8,1.428c-1.177,1.164-3.621,2.062-7.065,2.677l-.061.012a79.541,79.541,0,0,1-11.913.961l-.974.019a221.527,221.527,0,0,1-33.1-2.576c-5.221-.76-10.246-1.656-14.965-2.637h-.008c-15.539-3.217-27.792-7.377-33.092-11.18-.233-.168-.449-.341-.658-.5a5.258,5.258,0,0,1-2.169-2.961,2.123,2.123,0,0,1-.012-.651,2.4,2.4,0,0,1,.145-.516,2.225,2.225,0,0,1,.281-.487,4.531,4.531,0,0,1,1.577-1.3c.181-.1.369-.191.561-.293a.285.285,0,0,0,.065-.028,16.75,16.75,0,0,1,2.453-.863c8.671-2.382,27.437-2.181,48.833.963,17.393,2.553,32.57,6.475,41.725,10.424a.028.028,0,0,1,.022.013c.94.4,1.814.812,2.621,1.213.008,0,.014.011.022.013,3.629,1.817,5.89,3.609,6.414,5.247a2.286,2.286,0,0,1,.1,1.025Z",
    transform: "translate(-159.858 -118.929)",
    fill: "#aeb7c5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12976",
    "data-name": "Path 12976",
    d: "M204,344.837a194.391,194.391,0,0,0-28.512,37.941,34.952,34.952,0,0,1-16.6-17.866c7.323-15.634,18.163-27.671,28.675-36.542A30.512,30.512,0,0,0,204,344.838Z",
    transform: "translate(-149.926 -122.736)",
    fill: "#aeb7c5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12977",
    "data-name": "Path 12977",
    d: "M388.752,400.139a34.838,34.838,0,0,1-20.965,11.579A193.7,193.7,0,0,0,352.25,366.88a30.765,30.765,0,0,0,11.865-3.524,30.42,30.42,0,0,0,8.532-6.795,114.288,114.288,0,0,1,5.809,10.335c.982,1.981,1.907,3.991,2.759,6.02q.867,2.02,1.636,4.069a106.608,106.608,0,0,1,5.9,23.155Z",
    transform: "translate(-178.835 -126.951)",
    fill: "#aeb7c5"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991",
    "data-name": "Rectangle 991",
    width: 24.716,
    height: 34.602,
    rx: 6.501,
    transform: "translate(92.037 253.756) rotate(-81.668)",
    fill: "#2eb3bd",
    opacity: 0.61,
    style: {
      isolation: "isolate"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_992",
    "data-name": "Rectangle 992",
    width: 76.472,
    height: 8.702,
    transform: "translate(93.606 331.252) rotate(-81.423)",
    fill: "#2eb3bd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12978",
    "data-name": "Path 12978",
    d: "M355.626,449.487a100.45,100.45,0,0,1-4.224,12.036,172.442,172.442,0,0,1-29.135,11.011c-.081.024-.161.042-.241.065-40.823,11.244-74.677,4.233-88.036,1.3a204.3,204.3,0,0,1-70.129-30.86c-5.751-3.942-10.684-7.767-14.751-11.154a103.386,103.386,0,0,1-.758-13.208c2.434,2.125,5.255,4.485,8.443,6.982a205.225,205.225,0,0,0,68.794,35.579c5.9,1.682,11.523,2.967,16.718,3.967q4.519.859,8.583,1.434a168.475,168.475,0,0,0,23.615,1.876,182.231,182.231,0,0,0,51.914-7.678c5.157-1.529,10.523-3.358,16.032-5.535,5.111-2.019,9.541-4.041,13.175-5.813Z",
    transform: "translate(-148.351 -136.238)",
    fill: "#2eb3bd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12979",
    "data-name": "Path 12979",
    d: "M201.76,518.2q-3.289-1.933-6.384-4.1c-.645-.451-1.282-.9-1.906-1.362a98.222,98.222,0,0,0,3.6-13.73,10.239,10.239,0,0,0-.669-6.759A10.036,10.036,0,0,0,193,488.684a8.883,8.883,0,0,0-1.929-.828,189.367,189.367,0,0,1-32.037-17.889c-.233-.522-.466-1.044-.7-1.574a111.587,111.587,0,0,1-4.932-13.7c.215.173.446.357.669.532a211.519,211.519,0,0,0,45.564,27.17,11.15,11.15,0,0,1,2.153.926,12.2,12.2,0,0,1,6.047,13.26,99.875,99.875,0,0,1-6.073,21.616Z",
    transform: "translate(-149.105 -141.622)",
    fill: "#2eb3bd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12980",
    "data-name": "Path 12980",
    d: "M365.025,489.157a107.539,107.539,0,0,1-10.19,13.012,189.834,189.834,0,0,1-34.136,7.306,8.664,8.664,0,0,0-2.091.241,10.107,10.107,0,0,0-4.294,2.414,10.285,10.285,0,0,0-2.591,6.286,99.327,99.327,0,0,0-.561,12.992q-4.687,1.7-9.566,2.94a99.55,99.55,0,0,1,.527-21.377,12.206,12.206,0,0,1,9.626-10.942,11.185,11.185,0,0,1,2.33-.257,211.845,211.845,0,0,0,50.945-12.615Z",
    transform: "translate(-171.214 -146.775)",
    fill: "#2eb3bd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12981",
    "data-name": "Path 12981",
    d: "M318.334,315.352c-10.62-1.913-26.461-1.106-38.965,3.983-3.142,1.28-9.441,4.2-18.087,3.964h-.009c-4.047-.112-6.9-.862-11.171-2.016-6.976-1.887-17.052-5.547-21.921-9.164-.233-.168-.449-.341-.658-.5a5.611,5.611,0,0,1-2.169-2.961,2.113,2.113,0,0,1-.012-.651,2.43,2.43,0,0,1,.145-.517,2.623,2.623,0,0,1,.282-.486,5.009,5.009,0,0,1,1.577-1.3c.181-.1.37-.191.561-.293a.284.284,0,0,0,.065-.028c.511-.261,1.05-.533,1.6-.8.282-.024.566-.048.847-.062,8.671-2.382,27.437-2.181,48.833.963,17.393,2.552,32.571,6.474,41.725,10.424-.841-.206-1.719-.395-2.646-.552Z",
    transform: "translate(-159.858 -118.929)",
    fill: "#232952",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12982",
    "data-name": "Path 12982",
    d: "M375.275,429.514q-.639,2.973-1.452,5.891a100.291,100.291,0,0,1-4.224,12.036,103.708,103.708,0,0,1-9.239,17.093,107.472,107.472,0,0,1-10.19,13.012A109.7,109.7,0,0,1,306.5,506.785q-4.69,1.7-9.566,2.94a102.6,102.6,0,0,1-26.869,3.222,147.932,147.932,0,0,0,21.993-9.311c13.412-6.992,29.939-15.615,42.222-34.362a81.574,81.574,0,0,0,5.946-10.756,85.518,85.518,0,0,0,4.393-11.764,123.221,123.221,0,0,0,3.042-13.555c4.786-26.961-3.008-50.471-3.008-50.471-2.672-8.7-7.542-23.918-21.247-37.9a81.513,81.513,0,0,0-17.1-13.306c1.743.06,15.806.532,18.263.073a33.192,33.192,0,0,0,4.351-.834c.018-.005.043-.007.061-.012a35.362,35.362,0,0,0,7.065-2.677,5.788,5.788,0,0,0,.7-2.453,3.292,3.292,0,0,0-.144-1.135,118.711,118.711,0,0,1,23.757,27.274l0,.008a113.994,113.994,0,0,1,5.809,10.334c.981,1.982,1.906,3.992,2.758,6.021q.867,2.019,1.636,4.069a106.545,106.545,0,0,1,5.9,23.155,99.242,99.242,0,0,1-1.188,34.171Z",
    transform: "translate(-166.547 -122.155)",
    fill: "#232952",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12983",
    "data-name": "Path 12983",
    d: "M192.409,491.845A108.226,108.226,0,0,1,158.275,449.3c-.233-.522-.466-1.044-.7-1.574a111.578,111.578,0,0,1-4.932-13.7c-.167-.558-.325-1.114-.474-1.677A109.934,109.934,0,0,1,149.11,416.6a103.392,103.392,0,0,1-.758-13.209,98.835,98.835,0,0,1,2.044-19.533,93.256,93.256,0,0,1,6.92-20.727c7.324-15.635,18.163-27.672,28.676-36.543v-.008A135.071,135.071,0,0,1,199.7,316.452c-2.486,2.786-5.225,5.956-8.115,9.48-8.738,10.652-18.593,22.657-25.451,36.478-1.089,2.2-11.926,24.606-11.364,51.113.782,37.35,23.814,64.975,37.639,78.323Z",
    transform: "translate(-148.351 -120.955)",
    fill: "#fff",
    opacity: 0.49,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12984",
    "data-name": "Path 12984",
    d: "M342.946,326.03a6.684,6.684,0,0,1-4.089,3.183.137.137,0,0,0-.055.022,49.427,49.427,0,0,1-8.137,1.747,59.5,59.5,0,0,1-19.757-.145l-.016,0-.048-.012a115,115,0,0,0,11.943-1.536c8.6-1.562,12.945-2.39,14.582-5.105a6.575,6.575,0,0,0,.892-3.441c0-.11,0-.228-.009-.348.093.037.179.065.273.1q2.136,1.648,4.178,3.376c.236.194.463.394.69.595a5.045,5.045,0,0,1-.447,1.564Z",
    transform: "translate(-172.644 -121.544)",
    fill: "#fff",
    opacity: 0.49,
    style: {
      isolation: "isolate"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12985",
    "data-name": "Path 12985",
    d: "M330.33,284.707a11.116,11.116,0,0,1-5.614,1.226,137.754,137.754,0,0,1-55.059-8.21q-1.592-.583-3.119-1.19a137.173,137.173,0,0,1-30.464-16.846c-1.358-1-2.641-1.973-3.83-2.913a11.061,11.061,0,0,1-3.836-4.166,10.845,10.845,0,0,1-.729-8.352L274.913,94.251a11.351,11.351,0,0,1,5.384-6.425,10.973,10.973,0,0,1,3.53-1.129,11.258,11.258,0,0,1,3.2.01l.008,0A183.682,183.682,0,0,1,377.7,115.352c.089.046.188.105.3.168a11.123,11.123,0,0,1,3.017,2.574,10.129,10.129,0,0,1,1.205,1.822,11.408,11.408,0,0,1,.737,8.355l-47.241,150a11.483,11.483,0,0,1-5.387,6.433Z",
    transform: "translate(-160.134 -86.588)",
    fill: "#e9f0fa"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12986",
    "data-name": "Path 12986",
    d: "M335.915,257.624c-2.677.064-5.163.226-7.419.439a8.993,8.993,0,0,0-4.823,1.34,11.388,11.388,0,0,0-3.611,3.513,12.623,12.623,0,0,0-1.434,2.956l-1.8,5.293a97.437,97.437,0,0,1-54.119-13.477,101.059,101.059,0,0,1-9.987-6.732l1.559-6.41a12.725,12.725,0,0,0,.367-3.265,11.372,11.372,0,0,0-1.164-4.9,8.885,8.885,0,0,0-3.354-3.716c-1.563-1.221-3.3-2.5-5.2-3.8l44.755-142.14.009,0a183.575,183.575,0,0,1,84.433,24.843c2.228,1.293,4.3,2.566,6.236,3.8.089.046.188.106.3.168L335.914,257.623Z",
    transform: "translate(-162.789 -86.609)",
    fill: "#353f44"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_993",
    "data-name": "Rectangle 993",
    width: 52.552,
    height: 36.946,
    rx: 7,
    transform: "translate(93.152 133.794) rotate(-72.182)",
    fill: "url(#linear-gradient)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_994",
    "data-name": "Rectangle 994",
    width: 31.038,
    height: 34.593,
    rx: 7,
    transform: "translate(135.329 145.735) rotate(-72.182)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12987",
    "data-name": "Path 12987",
    d: "M337.252,290.245a11.116,11.116,0,0,1-5.614,1.226,137.753,137.753,0,0,1-55.059-8.21q-1.592-.583-3.119-1.19c25.294,3.89,44.234,5.252,51.879,4.077a17.1,17.1,0,0,0,9.715-4.286,16.633,16.633,0,0,0,4.616-9.19q19.263-60,38.766-119.9,4.737-14.574,9.5-29.135a10.156,10.156,0,0,1,1.205,1.822,11.411,11.411,0,0,1,.737,8.356l-47.241,150a11.48,11.48,0,0,1-5.388,6.433Z",
    transform: "translate(-167.055 -92.127)",
    fill: "#232952",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12988",
    "data-name": "Path 12988",
    d: "M339.041,261.992c-2.677.064-5.162.226-7.419.439a8.993,8.993,0,0,0-4.823,1.34,11.391,11.391,0,0,0-3.611,3.513,12.628,12.628,0,0,0-1.434,2.956l-1.8,5.293a97.435,97.435,0,0,1-54.119-13.477,209.923,209.923,0,0,0,40.346,1.771,36.3,36.3,0,0,0,6.19-.593c20.6-4.552,28.46-34.083,42.988-80.474,4.878-15.568,12.219-38.5,21.89-66.816,2.228,1.293,4.3,2.566,6.237,3.8.089.046.188.105.3.168L339.041,261.992Z",
    transform: "translate(-165.915 -90.977)",
    fill: "#15192f",
    opacity: 0.24,
    style: {
      isolation: "isolate"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12989",
    "data-name": "Path 12989",
    d: "M261.155,194.507Q277.515,144.2,293.875,93.9a126.423,126.423,0,0,1,13.183.724,129.429,129.429,0,0,1,40.175,11.156c-5.671-.712-14.1-1.6-24.457-2.062-9.473-.42-11.534-.078-12.933.275-11.98,3.02-17.97,17.585-21.633,26.418-8.169,19.695-16.966,40.295-27.055,64.1Z",
    transform: "translate(-165.216 -87.681)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12990",
    "data-name": "Path 12990",
    d: "M236.075,259.706c-1.358-1-2.641-1.973-3.83-2.913a11.061,11.061,0,0,1-3.836-4.166,10.842,10.842,0,0,1-.729-8.351L274.913,94.27a11.353,11.353,0,0,1,5.384-6.425,10.972,10.972,0,0,1,3.53-1.129c-1.368,2.171-2.893,4.767-4.443,7.745a109.175,109.175,0,0,0-7.173,17.245c-9.475,29.308-14.216,43.97-20.374,63.3-6.556,20.59-10.76,41.944-18.33,62.184a23.962,23.962,0,0,0-1.6,7.66,26.932,26.932,0,0,0,4.167,14.85Z",
    transform: "translate(-160.134 -86.607)",
    fill: "#fff",
    opacity: 0.49,
    style: {
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12991",
    "data-name": "Path 12991",
    d: "M267.5,376.836a5.309,5.309,0,0,1-3.416-6.459,5.293,5.293,0,0,1,2.643-3.3,5.169,5.169,0,0,1,2.9-.424c3.118.328,5.064,2.948,5.487,3.518.579.781,1.292,2.023,1.459,2.315.515.9.674,1.274.964,1.806a9.585,9.585,0,0,0,3.173,3.909,5.712,5.712,0,0,0,4.068.875,5.587,5.587,0,0,0,3.483-2.332,5.185,5.185,0,0,0,.983-3.5,4.923,4.923,0,0,0-.757-2.077,5.478,5.478,0,0,0-1.815-1.8,6.913,6.913,0,0,0-6.09.083,12.322,12.322,0,0,0-1.808,1.043l-.18.13a13.854,13.854,0,0,0-2.022,1.86c-.714.767-.852,1.036-1.3,1.549a8.744,8.744,0,0,1-4.058,2.792,5.9,5.9,0,0,1-3.71.005Z",
    transform: "translate(-165.626 -128.454)",
    fill: "none",
    stroke: "#139093",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinityWatching);
export default __webpack_public_path__ + "static/media/infinity-watching.a4830e9140cda0862c12cba4b4b8fe7d.svg";
export { ForwardRef as ReactComponent };